// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2RXs5","footer":"Form_footer__3_meT"};